<template>
  <div class="trainRecord2Box">
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <el-button type="primary" @click="handleAdd()" size="small">新建</el-button>
        <Input
          search
          enter-button
          placeholder="请输入课程/内容/讲师/地点"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px"
        />
      </div>
      <div style="margin-top: 20px;">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="courseName" label="培训课程">
            <template slot-scope="{ row }">
              <el-link type="primary" @click="detailBtn(row.id)">{{ row.courseName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="teacher" label="培训讲师"></el-table-column>
          <el-table-column prop="userNames" label="参加人员">
            <template slot-scope="{ row }">
              <el-popover
                v-if="row.userNames && row.userNames.length > 24"
                placement="top-start"
                title=""
                width="500"
                trigger="hover"
                :content="row.userNames">
                <span slot="reference">{{ row.userNames.substring(0,24) + '...' }}</span>
              </el-popover>
              <span v-else>{{ row.userNames }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="duration" label="培训课时"></el-table-column>
          <el-table-column prop="place" label="培训地点"></el-table-column>
          <el-table-column prop="organizationName" label="培训组织"></el-table-column>
          <el-table-column prop="actualStartTime" label="开始时间">
            <template slot-scope="{ row }">
              {{ row.actualStartTime | filter1 }}
            </template>
          </el-table-column>
          <el-table-column prop="actualEndTime" label="结束时间">
            <template slot-scope="{ row }">
              {{ row.actualEndTime | filter1 }}
            </template>
          </el-table-column>
          <el-table-column prop="trainStatus" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.trainStatus == 0">未开始</span>
              <span v-if="scope.row.trainStatus == 1">进行中</span>
              <span v-if="scope.row.trainStatus == 2">结束</span>
            </template>
          </el-table-column>
          <el-table-column prop="oper" label="操作" width="250">
            <template slot-scope="scope">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" v-if="scope.row.trainStatus == 0" @click="handChange(scope.row.id,scope.row)">编辑</el-link>
                <span style="margin: 0 5px;color: #e8e8e8" v-if="scope.row.trainStatus == 0">|</span>
                <el-link type="danger" @click="handleDel(scope.row.id)">删除</el-link>
                <span style="margin: 0 5px;color: #e8e8e8">|</span>
                <el-link
                  v-if="scope.row.trainStatus == 0"
                  type="success"
                  @click="startTrain(scope.row.id,1)"
                >开始培训</el-link>
                <el-link
                  v-if="scope.row.trainStatus == 1"
                  type="success"
                  @click="startTrain(scope.row.id,2)"
                >完成培训</el-link>
                <span style="margin: 0 5px;color: #e8e8e8" v-if="scope.row.trainStatus < 2">|</span>
                <el-link type="primary" @click="openDia(scope.row)">签到/上传照片</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <Page :total="total" :page-size="pageSize" @on-change="getData" :current="currentPage" />
        </div>
      </div>
    </div>
    <!-- 上传签到表，现场照片的弹窗 -->
    <el-dialog
      title="签到/上传照片"
      :visible.sync="dialogVisible"
      width="30%"
      :close="handleClose">
      <el-form :model="uploadForm" size="small" label-width="100px">
        <el-form-item label="现场照片">
          <el-upload
            class="avatar-uploader"
            action="/v1/trainMaterials/uploadFile"
            :show-file-list="false"
            accept=".jepg,.jpg,.png,.gif,.svg"
            :on-success="handleAvatarSuccess">
            <img v-if="imageUrl" :src="host + imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="签到表">
          <el-upload
            class="upload-demo"
            action="/v1/trainMaterials/uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="diaSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情的抽屉 -->
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :show-close="false"
      size="60%">
      <div slot="title" class="drawerTitle">
        <p>培训课程：{{ drawerInfo.courseName }}
          <i class="el-icon-circle-close" @click="drawer = false"></i>
        </p>
        <div class="tWord">
          <div><p>计划年度</p><span>{{ drawerInfo.planYear | timeFilter }}</span></div>
          <div><p>培训类型</p><span>{{ drawerInfo.cultivateType }}</span></div>
          <div><p>培训课时</p><span>{{ drawerInfo.duration }}（小时）</span></div>
          <div><p>培训单位</p><span>{{ drawerInfo.organizationName }}</span></div>
          <div><p>培训部门</p><span>{{ drawerInfo.organizationDepName }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="详情" name="first"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <el-form :model="drawerInfo" label-width="150px">
            <el-form-item label="培训讲师：">
              {{ drawerInfo.teacher }}
            </el-form-item>
            <el-form-item label="培训地点：">
              {{ drawerInfo.place }}
            </el-form-item>
            <el-form-item label="培训资料：">
              {{ drawerInfo.legislationNames }}
            </el-form-item>
            <el-form-item label="培训简介：">
              {{ drawerInfo.contentHtml }}
            </el-form-item>
            <el-form-item label="参加人员：">
              {{ drawerInfo.empList }}
            </el-form-item>
            <el-form-item label="参加人数：">
              {{ drawerInfo.turnout }}
            </el-form-item>
            <el-form-item label="及格分数：">
              {{ drawerInfo.passMark }}
            </el-form-item>
            <el-form-item label="培训费用：">
              {{ drawerInfo.trainingCost }}（单位：元）
            </el-form-item>
            <el-form-item label="实施日期：">
              {{ drawerInfo.estStartTime | timeFilter }}
            </el-form-item>
            <el-form-item label="完成日期：">
              {{ drawerInfo.estEndTime | timeFilter }}
            </el-form-item>
            <el-form-item label="考核单位：">
              {{ drawerInfo.assessDepName }}
            </el-form-item>
            <el-form-item label="编制部门：">
              {{ drawerInfo.editorDepName }}
            </el-form-item>
            <el-form-item label="编制人：">
              {{ drawerInfo.editorEmpName }}
            </el-form-item>
            <el-form-item label="制定时间：">
              {{ drawerInfo.createTime }}
            </el-form-item>
            <el-form-item label="实际开始时间：">
              {{ drawerInfo.actualStartTime | timeFilter }}
            </el-form-item>
            <el-form-item label="实际结束时间：">
              {{ drawerInfo.actualEndTime | timeFilter }}
            </el-form-item>
            <el-form-item label="现场照片：">
              <img :src="host + drawerInfo.sitePhotos" alt="">
            </el-form-item>
            <el-form-item label="签到表：">
              <el-link type="primary" @click="download">{{ drawerInfo.signInFieName }}</el-link>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <div class="drawerBox">
        <div>培训课程：{{ drawerInfo.courseName }}</div>
        <div>计划年度：{{ drawerInfo.planYear | timeFilter }}</div>
        <div>培训类型：{{ drawerInfo.cultivateType }}</div>
        <div>培训课时：{{ drawerInfo.duration }}（小时）</div>
        <div>培训单位：{{ drawerInfo.organizationName }}</div>
        <div>培训部门：{{ drawerInfo.organizationDepName }}</div>
        <div>培训讲师：{{ drawerInfo.teacher }}</div>
        <div>培训地点：{{ drawerInfo.place }}</div>
        <div>培训资料：{{ drawerInfo.legislationNames }}</div>
        <div>培训简介：{{ drawerInfo.contentHtml }}</div>
        <div>参加人员：{{ drawerInfo.empList }}</div>
        <div>参加人数：{{ drawerInfo.turnout }}</div>
        <div>及格分数：{{ drawerInfo.passMark }}</div>
        <div>培训费用：{{ drawerInfo.trainingCost }}（单位：元）</div>
        <div>实施日期：{{ drawerInfo.estStartTime | timeFilter }}</div>
        <div>完成日期：{{ drawerInfo.estEndTime | timeFilter }}</div>
        <div>考核单位：{{ drawerInfo.assessDepName }}</div>
        <div>编制部门：{{ drawerInfo.editorDepName }}</div>
        <div>编制人：{{ drawerInfo.editorEmpName }}</div>
        <div>制定时间：{{ drawerInfo.createTime }}</div>
        <div>实际开始时间：{{ drawerInfo.actualStartTime | timeFilter }}</div>
        <div>实际结束时间：{{ drawerInfo.actualEndTime | timeFilter }}</div>
        <div v-if="drawerInfo.sitePhotos">现场照片：<img :src="host + drawerInfo.sitePhotos" alt=""></div>
        <div v-if="drawerInfo.signInFieName">签到表：
          <el-link type="primary" @click="download">{{ drawerInfo.signInFieName }}</el-link>
        </div>
      </div> -->
    </el-drawer>
  </div>
</template>


<script>
import { trainingSign, cultivateInfo } from "@/api/processManager"
import { downLoadDocument } from "@/api/downLoad"
export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      fileNameOrTag: "",
      dialogVisible: false,
      fileList: [],
      uploadForm: {},
      imageUrl: '',
      dataId: null, // 某个条目的id(弹窗上传的时候用)
      drawer: false,
      drawerInfo: {}, // 某条培训记录的详情数据
      activeName: 'first'
    };
  },
  filters: {
    filter1(time) {
      if(time) {
        return time.split(':')[0] + ':' + time.split(':')[1]
      }else {
        return ''
      }
    }
  },
  mounted: function() {
    this.getData(1);
  },
  created() {},
  methods: {
    getData(page) {
      this.currentPage = page;
      this.componentsMoudel.httpRequest
        .getRequestHander(
          "/cultivate/list_all" +
            "?limit=" +
            this.pageSize +
            "&curPage=" +
            page +
            "&searchParam=" +
            this.fileNameOrTag
        )
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data;
          this.total = res.body.cum;
          this.pageTotal = res.body.pageTotal;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleAdd() {
      this.$router.push({
        path: "addTrainReocrd"
      });
    },
    handChange(id, row) {
      let obj = { ...row }
      for(let i in obj){
        if(obj[i] === null) {
          delete obj[i]
        }
      }
      obj.cultivateEmp = obj.empList
      delete obj.empList
      this.$router.push({
        name: "addTrainReocrd",
        params: { key: obj }
      });
    },
    startTrain(id, status) {
      // 更新培训状态
      let formData = new FormData();
      formData.append("id", id);
      formData.append("trainStatus", status);
      this.componentsMoudel.httpRequest
        .getRequestHander("/cultivate/updateStatus")
        .openLoad()
        .startPost(formData)
        .then(res => {
          this.getData(1);
          this.$message({
            showClose: true,
            message: "开始培训成功",
            type: "success"
          });
        });
    },
    handleDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander("/cultivate/delete/" + id)
        .openLoad()
        .startPost()
        .then(res => {
          if (this.tableData.length <= 1 && this.currentPage > 1) {
            this.currentPage -= 1;
          }
          this.getData(this.currentPage);
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
        });
    },
    // 弹窗的事件
    openDia(row) {
      this.dataId = row.id
      this.dialogVisible = true;
    },
    handleClose() {
      this.fileList = [];
      this.imageUrl = '';
      this.dialogVisible = false;
    },
    // 上传照片
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data
    },
    // 上传文件
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      this.$message.warning(`限制上传一个文件`);
    },
    // 弹窗的保存按钮
    diaSubmit() {
      if (this.fileList.length === 0 && this.imageUrl === '') {
        this.$message.warning('现场照片或签到表未上传')
      } else if (this.fileList.length === 0 ) {
        this.$message.warning('签到表未上传')
      }else if (this.imageUrl === '') {
        this.$message.warning('现场照片未上传')
      }else {
        let obj = {}
        if (this.fileList.length > 0) {
          obj.signInFieName = this.fileList[0].name
          obj.signInFieUrl = this.fileList[0].response.data
        }
        obj.sitePhotos = this.imageUrl
        obj.id = this.dataId
        trainingSign({ ...obj }).then(res => {
          this.$message.success('保存成功')
          this.handleClose()
        })
      }
    },
    // 详情
    detailBtn(id) {
      cultivateInfo(id).then(res => {
        this.drawer = true
        this.$nextTick(() => {
          this.drawerInfo = res.body.data
          let arr = []
          for(let i in res.body.data.empList) {
            arr.push(res.body.data.empList[i].empName)
          }
          this.drawerInfo.empList = arr.join(',')
        })
      })
    },
    // 下载文件
    download() {
      downLoadDocument(this.drawerInfo.signInFieUrl, this.drawerInfo.signInFieName)
    }
  }
};
</script>

<style scoped>
.head {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}

.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}

.addBtn {
  width: 100px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding-left: 15px;
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0;
  margin-bottom: 0
}

/* 解决tab切换会有蓝色边框的问题 */
.trainRecord2Box /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 120px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
